import script from "./WalletPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletPanel.vue?vue&type=script&setup=true&lang=js"

import "./WalletPanel.vue?vue&type=style&index=0&id=2a56af4d&scoped=true&lang=css"
import "./WalletPanel.vue?vue&type=style&index=1&id=2a56af4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a56af4d"]])

export default __exports__